let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lPCqB"), load("aQtq6"), load("jSPit"), load("gGI57"), load("7XPb0")]).then(() => parcelRequire('e56cD'));